"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegativeMangopayEventTypes = exports.PositiveMangopayEventTypes = exports.MiscMangopayEventTypes = exports.MangopayEvent = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const MangopayEventType_1 = require("./MangopayEventType");
let MangopayEvent = class MangopayEvent {
    ResourceId;
    EventType;
    Date;
};
exports.MangopayEvent = MangopayEvent;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", String)
], MangopayEvent.prototype, "ResourceId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MangopayEvent.prototype, "EventType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)()
    // @Type(() => Date)
    ,
    __metadata("design:type", Number)
], MangopayEvent.prototype, "Date", void 0);
exports.MangopayEvent = MangopayEvent = __decorate([
    (0, class_transformer_1.Exclude)()
], MangopayEvent);
exports.MiscMangopayEventTypes = [
    MangopayEventType_1.MangopayEventType.PAYIN_NORMAL_CREATED,
    MangopayEventType_1.MangopayEventType.PAYOUT_NORMAL_CREATED,
    MangopayEventType_1.MangopayEventType.TRANSFER_NORMAL_CREATED,
    MangopayEventType_1.MangopayEventType.PAYIN_REFUND_CREATED,
    MangopayEventType_1.MangopayEventType.PAYOUT_REFUND_CREATED,
    MangopayEventType_1.MangopayEventType.TRANSFER_REFUND_CREATED,
    MangopayEventType_1.MangopayEventType.KYC_CREATED,
    MangopayEventType_1.MangopayEventType.KYC_VALIDATION_ASKED,
    MangopayEventType_1.MangopayEventType.PAYIN_REPUDIATION_CREATED,
    MangopayEventType_1.MangopayEventType.DISPUTE_DOCUMENT_CREATED,
    MangopayEventType_1.MangopayEventType.DISPUTE_DOCUMENT_VALIDATION_ASKED,
    MangopayEventType_1.MangopayEventType.DISPUTE_CREATED,
    MangopayEventType_1.MangopayEventType.DISPUTE_SUBMITTED,
    MangopayEventType_1.MangopayEventType.DISPUTE_ACTION_REQUIRED,
    MangopayEventType_1.MangopayEventType.DISPUTE_FURTHER_ACTION_REQUIRED,
    MangopayEventType_1.MangopayEventType.DISPUTE_CLOSED,
    MangopayEventType_1.MangopayEventType.DISPUTE_SENT_TO_BANK,
    MangopayEventType_1.MangopayEventType.TRANSFER_SETTLEMENT_CREATED,
    MangopayEventType_1.MangopayEventType.MANDATE_CREATED,
    MangopayEventType_1.MangopayEventType.MANDATE_ACTIVATED,
    MangopayEventType_1.MangopayEventType.MANDATE_SUBMITTED,
    MangopayEventType_1.MangopayEventType.PREAUTHORIZATION_PAYMENT_WAITING,
    MangopayEventType_1.MangopayEventType.PREAUTHORIZATION_PAYMENT_EXPIRED,
    MangopayEventType_1.MangopayEventType.PREAUTHORIZATION_PAYMENT_CANCELED,
    MangopayEventType_1.MangopayEventType.PREAUTHORIZATION_PAYMENT_VALIDATED,
    MangopayEventType_1.MangopayEventType.UBO_DECLARATION_CREATED,
    MangopayEventType_1.MangopayEventType.UBO_DECLARATION_VALIDATION_ASKED,
    MangopayEventType_1.MangopayEventType.UBO_DECLARATION_REFUSED,
    MangopayEventType_1.MangopayEventType.UBO_DECLARATION_VALIDATED,
];
exports.PositiveMangopayEventTypes = [
    MangopayEventType_1.MangopayEventType.PAYIN_NORMAL_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.PAYOUT_NORMAL_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.TRANSFER_NORMAL_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.PAYIN_REFUND_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.PAYOUT_REFUND_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.TRANSFER_REFUND_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.KYC_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.PAYIN_REPUDIATION_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.DISPUTE_DOCUMENT_SUCCEEDED,
    MangopayEventType_1.MangopayEventType.TRANSFER_SETTLEMENT_SUCCEEDED,
];
exports.NegativeMangopayEventTypes = [
    MangopayEventType_1.MangopayEventType.PAYIN_NORMAL_FAILED,
    MangopayEventType_1.MangopayEventType.PAYOUT_NORMAL_FAILED,
    MangopayEventType_1.MangopayEventType.TRANSFER_NORMAL_FAILED,
    MangopayEventType_1.MangopayEventType.PAYIN_REFUND_FAILED,
    MangopayEventType_1.MangopayEventType.PAYOUT_REFUND_FAILED,
    MangopayEventType_1.MangopayEventType.TRANSFER_REFUND_FAILED,
    MangopayEventType_1.MangopayEventType.KYC_FAILED,
    MangopayEventType_1.MangopayEventType.PAYIN_REPUDIATION_FAILED,
    MangopayEventType_1.MangopayEventType.DISPUTE_DOCUMENT_FAILED,
    MangopayEventType_1.MangopayEventType.TRANSFER_SETTLEMENT_FAILED,
    MangopayEventType_1.MangopayEventType.MANDATE_FAILED,
];
//# sourceMappingURL=MangopayEvent.js.map